<aran-page-title
  [headerConfig]="{
    bannerTitle: appInfo.appName + ' | ' + routeMetaData.myAccount.title
  }"
  [dropdownConfig]="{
    isVisibleButton: true,
    buttonName: 'Actions',
    menu: actionMenuComponent.menu
  }"
></aran-page-title>

<aran-menu #actionMenuComponent [menuItems]="menuItems"></aran-menu>

<section *ngIf="userDetail$ | async as userDetail" class="my-account">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="my-account-banner"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="my-account-banner__title">Information</div>
    </div>
  </div>

  <div class="my-account__detail-container my-account__detail-container-info">
    <div class="my-account__detail-container--row">
      <div class="my-account__detail-container--row-title" fxLayout="row">
        Administrative Information
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="my-account__detail-container--row-sub"
      >
        <aran-detail-card
          fxFlex="23%"
          [label]="'Email'"
          [data]="userDetail.email ?? '-'"
        >
        </aran-detail-card>
      </div>
    </div>
    <div class="my-account__detail-container--row">
      <div class="my-account__detail-container--row-title" fxLayout="row">
        Organization Information
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="my-account__detail-container--row-sub"
      >
        <aran-detail-card
          fxFlex="23%"
          [label]="'Name'"
          [data]="userDetail.organizationName ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          [label]="'Email'"
          [data]="userDetail.organizationEmail ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          [label]="'Address'"
          [data]="userDetail.organizationAddress ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Website"
          [data]="userDetail.organizationWebsite ?? '-'"
        >
        </aran-detail-card>
      </div>
    </div>

    <div class="my-account__detail-container--row">
      <div class="my-account__detail-container--row-title" fxLayout="row">
        General Information
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="my-account__detail-container--row-sub"
      >
        <aran-detail-card
          fxFlex="23%"
          label="Name"
          [data]="userDetail.generalSRName ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Surname"
          [data]="userDetail.generalSRSurname ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Email"
          [data]="userDetail.generalSREmail ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Phone"
          [data]="userDetail.generalSRPhone ?? '-'"
        >
        </aran-detail-card>
      </div>
    </div>

    <div class="my-account__detail-container--row">
      <div class="my-account__detail-container--row-title" fxLayout="row">
        Technical Information
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="my-account__detail-container--row-sub"
      >
        <aran-detail-card
          fxFlex="23%"
          label="Name"
          [data]="userDetail.technicalSRName ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Surname"
          [data]="userDetail.technicalSRSurname ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Email"
          [data]="userDetail.technicalSREmail ?? '-'"
        >
        </aran-detail-card>

        <aran-detail-card
          fxFlex="23%"
          label="Phone"
          [data]="userDetail.technicalSRPhone ?? '-'"
        >
        </aran-detail-card>
      </div>
    </div>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="my-account-banner"
    *ngIf="!(isLoading$ | async)"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="my-account-banner__title">Services</div>
    </div>
  </div>
  <div
    class="my-account__detail-container"
    *ngIf="userDetail.topics.length; else noDataTemplate"
  >
    <div
      class="account__service-category"
      *ngFor="let item of userDetail.topics; let i = index"
    >
      <div class="account__service-category-title" fxLayout="row">
        {{ item.description }}
      </div>

      <div class="flex-col">
        <ng-container *ngIf="!item?.topicAreas?.length">
          <ng-container
            *ngTemplateOutlet="scenariosContentTemplate"
          ></ng-container>
        </ng-container>

        <aran-tabs
          *ngIf="item?.topicAreas?.length"
          [tabs]=" [
          {
            label: 'Scenarios',
            template: scenariosContentTemplate,
          },
          {
            label: 'Airports',
            template: airportsContentTemplate,
          },
          {
            label: 'FIRs',
            template: firsContentTemplate,
          },
        ]"
          [selectedIndex]="selectedIndexes[i]"
          (tabChanged)="onTabChanged($event, i)"
          [design]="'underline'"
          [fitInkBarToContent]="true"
          [stretchTabs]="false"
          [alignTabs]="'start'"
          [dynamicHeight]="false"
          [animationDuration]="'300ms'"
          [ignoreContentAnimation]="true"
        >
        </aran-tabs>

        <ng-template #scenariosContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="
              item.subTopics.length > 1 &&
              item.subTopicSelectedOption === 'Custom'
            "
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getScenarioKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getScenarioKey(i))"
                (handleReset)="resetFilter(getScenarioKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            *ngIf="
              item.subTopicSelectedOption !== 'None';
              else noInfoFoundTemplate
            "
            class="px-4 pt-4 account__serviceSelectedOption"
          >
            {{ item.subTopicSelectedOption }}
          </div>

          <div
            *ngIf="
              item.subTopicSelectedOption === 'Custom' ||
              (!item.subTopicSelectedOption && item.topicAreas.length === 0)
            "
          >
            <div
              class="account__service-value"
              fxLayout="column"
              fxLayoutAlign="start start"
              *ngIf="item.subTopics.length; else noInfoFoundTemplate"
            >
              <ng-container
                *ngIf="
                  (
                    item.subTopics
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length;
                  else noInfoMatchedFoundTemplate
                "
              >
                <div
                  class="pl-4"
                  *ngFor="
                    let service of item.subTopics
                      | filterByText
                        : filters[getScenarioKey(i)]
                        : 'description'
                      | paginate : pagingConfig[getScenarioKey(i)]
                  "
                >
                  {{ service.description }}
                </div>
              </ng-container>
            </div>

            <div
              class="mt-4 w-full"
              *ngIf="
                (
                  item.subTopics
                  | filterByText : filters[getScenarioKey(i)] : 'description'
                ).length > itemsPerPage
              "
            >
              <aran-pagination
                [uniqueKey]="getScenarioKey(i)"
                [totalItems]="
                  (
                    item.subTopics
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length
                "
                [currentPage]="pagingConfig[getScenarioKey(i)].currentPage"
                [itemsPerPage]="pagingConfig[getScenarioKey(i)].itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [maxSize]="maxSize"
                [footerTablePagination]="
                  pagingConfig[getScenarioKey(i)].footerTablePagination
                "
                (handlePaginate)="onHandlePaginate($event, getScenarioKey(i))"
                (handleChangePageSize)="
                  onHandlePageSize($event, getScenarioKey(i))
                "
              ></aran-pagination>
            </div>
          </div>
        </ng-template>
        <ng-template #airportsContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="
              (item?.topicAreas | areaType : ['Aerodrome', 'Heliport']).length >
                1 && item.topicAreaSelectedOption === 'Custom'
            "
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getAirportKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getAirportKey(i))"
                (handleReset)="resetFilter(getAirportKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            *ngIf="
              item.topicAreaSelectedOption &&
                item.topicAreaSelectedOption !== 'None';
              else noInfoFoundTemplate
            "
            class="px-4 pt-4 account__serviceSelectedOption"
          >
            {{ item.topicAreaSelectedOption }}
          </div>

          <div *ngIf="item.topicAreaSelectedOption === 'Custom'">
            <div
              class="account__service-value"
              fxLayout="column"
              fxLayoutAlign="start start"
              *ngIf="
                (item.topicAreas | areaType : ['Aerodrome', 'Heliport']).length;
                else noInfoFoundTemplate
              "
            >
              <ng-container
                *ngIf="
                  (
                    item.topicAreas
                    | areaType : ['Aerodrome', 'Heliport']
                    | filterByText : filters[getAirportKey(i)] : 'code'
                  ).length;
                  else noInfoMatchedFoundTemplate
                "
              >
                <div
                  class="pl-4"
                  *ngFor="
                    let service of item.topicAreas
                      | areaType : ['Aerodrome', 'Heliport']
                      | filterByText : filters[getAirportKey(i)] : 'code'
                      | paginate : pagingConfig[getAirportKey(i)]
                  "
                >
                  {{ service.code }}
                </div>
              </ng-container>
            </div>

            <div
              class="mt-4 w-full"
              *ngIf="
                (
                  item?.topicAreas
                  | areaType : ['Aerodrome', 'Heliport']
                  | filterByText : filters[getAirportKey(i)] : 'code'
                ).length > itemsPerPage
              "
            >
              <aran-pagination
                [uniqueKey]="getAirportKey(i)"
                [totalItems]="pagingConfig[getAirportKey(i)].totalItems"
                [currentPage]="pagingConfig[getAirportKey(i)].currentPage"
                [itemsPerPage]="pagingConfig[getAirportKey(i)].itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [maxSize]="maxSize"
                [footerTablePagination]="
                  pagingConfig[getAirportKey(i)].footerTablePagination
                "
                (handlePaginate)="onHandlePaginate($event, getAirportKey(i))"
                (handleChangePageSize)="
                  onHandlePageSize($event, getAirportKey(i))
                "
              ></aran-pagination>
            </div>
          </div>
        </ng-template>
        <ng-template #firsContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="(item?.topicAreas | areaType : 'Airspace').length > 1"
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getFirKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getFirKey(i))"
                (handleReset)="resetFilter(getFirKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            class="account__service-value"
            fxLayout="column"
            fxLayoutAlign="start start"
            *ngIf="
              (item.topicAreas | areaType : 'Airspace').length;
              else noInfoFoundTemplate
            "
          >
            <ng-container
              *ngIf="
                (
                  item.topicAreas
                  | areaType : 'Airspace'
                  | filterByText : filters[getFirKey(i)] : 'code'
                ).length;
                else noInfoMatchedFoundTemplate
              "
            >
              <div
                *ngFor="
                  let service of item.topicAreas
                    | areaType : 'Airspace'
                    | filterByText : filters[getFirKey(i)] : 'code'
                    | paginate : pagingConfig[getFirKey(i)]
                "
              >
                {{ service.code }}
              </div>
            </ng-container>
          </div>

          <div
            class="mt-4 w-full"
            *ngIf="
              (
                item?.topicAreas
                | areaType : 'Airspace'
                | filterByText : filters[getFirKey(i)] : 'code'
              ).length > itemsPerPage
            "
          >
            <aran-pagination
              [uniqueKey]="getFirKey(i)"
              [totalItems]="
                (
                  item.topicAreas
                  | areaType : 'Airspace'
                  | filterByText : filters[getFirKey(i)] : 'code'
                ).length
              "
              [currentPage]="pagingConfig[getFirKey(i)].currentPage"
              [itemsPerPage]="pagingConfig[getFirKey(i)].itemsPerPage"
              [pageSizeOptions]="pageSizeOptions"
              [maxSize]="maxSize"
              [footerTablePagination]="
                pagingConfig[getFirKey(i)].footerTablePagination
              "
              (handlePaginate)="onHandlePaginate($event, getFirKey(i))"
              (handleChangePageSize)="onHandlePageSize($event, getFirKey(i))"
            ></aran-pagination>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <ng-container>
    <ng-template #changePassword>
      <app-change-password></app-change-password>
    </ng-template>

    <ng-template #modalfieldsUpdate>
      <app-update [accountDetail$]="userDetail$"></app-update>
    </ng-template>

    <aran-drawer-modal
      [isDrawerOpen]="false"
      [templateRef]="currentTemplate"
      [modalTitle]="modalTitle"
    ></aran-drawer-modal>
  </ng-container>
</section>

<ng-template #noDataTemplate>
  <ng-container *ngIf="!(isLoading$ | async)">
    <aran-no-data text="No information found"></aran-no-data>
  </ng-container>
</ng-template>

<ng-template #noInfoFoundTemplate>
  <ng-container *ngIf="!(isLoading$ | async)">
    <div class="noInfoFound py-2 px-4">No information found</div>
  </ng-container>
</ng-template>

<ng-template #noInfoMatchedFoundTemplate>
  <ng-container *ngIf="!(isLoading$ | async)">
    <div class="noInfoFound py-2">No matching results found</div>
  </ng-container>
</ng-template>
